import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FolderPlus, FileText, Search } from "lucide-react";
const WelcomeScreen = () => {
    const features = [
        {
            icon: _jsx(FolderPlus, { className: "w-8 h-8 text-blue-500" }),
            title: "Browse Your Drive",
            description: "Effortlessly browse through all the files stored in your drive. View files with ease.",
        },
        {
            icon: _jsx(FileText, { className: "w-8 h-8 text-green-500" }),
            title: "Add Files to Project",
            description: "Quickly add files from your drive to the project. Organize your files and make them readily available for the task at hand.",
        },
        {
            icon: _jsx(Search, { className: "w-8 h-8 text-purple-500" }),
            title: "Query Files",
            description: "Search and filter files based on specific queries. Find exactly what you need by applying smart filters and search criteria.",
        },
    ];
    return (_jsx("div", { className: "w-full h-full flex flex-col items-center justify-center p-8 bg-gradient-to-br from-white to-blue-50", children: _jsx("div", { className: "max-w-4xl w-full text-center space-y-12", children: _jsxs("div", { className: "space-y-4", children: [_jsx("h1", { className: "text-4xl md:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-purple-600", children: "Welcome to Email Mode" }), _jsx("span", { className: " text-lg text-gray-700 font-semibold font-content text-right mb-2", children: "powered by Agentspace" }), _jsx("h2", { className: "text-xl md:text-2xl text-gray-600", children: "Effortlessly manage your email, and quickly search for what you need. Let\u2019s make email management a breeze!" })] }) }) }));
};
export default WelcomeScreen;
